import { Component, OnInit } from '@angular/core';
import { ComunicacionService } from 'src/services/comunicacion.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-evaluation-menu',
  templateUrl: './evaluation-menu.component.html',
  styleUrls: ['./evaluation-menu.component.css']
})
export class EvaluationMenuComponent implements OnInit {

  constructor(private comunicacionService: ComunicacionService, private router: Router) { }

  ngOnInit() {
  }
  AgregarMatriz() {
    this.comunicacionService.setParametrosMatriz([]);
    this.router.navigate(['/v2/agregarmatriz']);
  }
}
